import * as analytics from '@wix/analytics';
import * as consentPolicyManager from '@wix/consent-policy-manager';
import { createWebsiteModule } from './websiteHostModule.js';
import { createHost } from './hostPlatform.js';
export const site = createWebsiteModule({ createHost });
export * from './types.js';
export { analytics, consentPolicyManager };
//# sourceMappingURL=index.js.map